import React, { ReactNode } from "react";
import { useDraggable } from '@dnd-kit/core';
import { Box, Tooltip } from "@mui/material";
import { QueryBuilderAddButton } from "./QueryBuilderAddButton";
import { useTranslation } from "react-i18next";

export interface QueryBuilderAddButtonDraggableProps {
  op?: string;
  title?: string;
  onClick: (op: string) => void;
  children?: ReactNode;
}

export function QueryBuilderAddButtonDraggable(props: QueryBuilderAddButtonDraggableProps): JSX.Element {
  const { i18n } = useTranslation();
  const { attributes, listeners, setNodeRef } = useDraggable({
    id: `op-${props.op || "null"}`,
  });

  return (
    <Box sx={{zIndex:1000}} {...listeners} {...attributes} ref={setNodeRef}>
      <Tooltip title={i18n.t(`query-form.operator-tooltips.${props.op || null}`)} followCursor={true}>
        <Box>
        <QueryBuilderAddButton op={props.op} onClick={props.onClick}>
            {props.title}
            {props.children}
          </QueryBuilderAddButton>
        </Box>
      </Tooltip>
    </Box>
  );
}
